export default __webpack_public_path__ + "static/media/Nellie.d928e493.jpg";